<template>
  <div
    class="poll-card card--liftable"
    :class="{ 'poll-card--voted': poll.user_has_voted }"
    role="button"
    tabindex="0"
    @click="navigate"
    @keydown.enter="navigate"
  >
    <div class="poll-card__header">
      <h3 class="poll-card__title">{{ poll.title }}</h3>
      <span v-if="poll.user_has_voted" class="poll-card__voted-badge" title="Ați votat la acest sondaj">
        <i class="mdi mdi-check" aria-hidden="true"></i> VOTAT
      </span>
    </div>
    <div class="poll-card__meta">
      <span class="poll-card__meta-item">{{ votesLabel }}</span>
      <span class="poll-card__meta-sep">·</span>
      <span class="poll-card__meta-item">{{ optionsLabel }}</span>
      <span class="poll-card__meta-sep">·</span>
      <span class="poll-card__meta-item">{{ formattedDate }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "PollCard",

  props: {
    poll: {
      type: Object,
      required: true,
    },
  },

  computed: {
    votesLabel() {
      const n = this.poll.total_votes || 0;
      return n === 1 ? "1 vot" : `${n} voturi`;
    },
    optionsLabel() {
      const n = this.poll.options_count || 0;
      return n === 1 ? "1 opțiune" : `${n} opțiuni`;
    },
    formattedDate() {
      return new Date(this.poll.created_at).toLocaleDateString("ro-RO", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },

  methods: {
    navigate() {
      console.log("Navigating to poll", this.poll);
      this.$router.push({ name: "polls.show", params: { id: this.poll.id, slug: this.poll.slug || 'vote' } });
    },
  },
};
</script>
